import DemoCard from '../DemoCard'
import { DemoSectionProps } from '../types'

const Groups = ({ triggerDemo }: DemoSectionProps ) => {
  const demos = [
    {
      demo: 'resetGroups',
      isReset: true,
      buttonText: 'Reset Groups',
      features: [
        'Delete all Groups'
      ]
    },
    {
      demo: 'oneGroup',
      isReset: false,
      buttonText: 'One Group',
      features: [
        'All practices in one group'
      ]
    },
    {
      demo: 'twoGroup',
      isReset: false,
      buttonText: 'Two Group',
      features: [
        'Practices split evenly between two groups'
      ]
    },
    {
      demo: 'twoGroupsSomeUnassigned',
      isReset: false,
      buttonText: 'Two Groups, Some Unassigned',
      features: [
        '33% Group A',
        '33% Group B',
        '33% no group'
      ]
    },
    {
      demo: 'twoGroupsWithOverlap',
      isReset: false,
      buttonText: 'Two Groups with Overlap',
      features: [
        '40% Group A',
        '40% Group B',
        '20% Group A and Group B'
      ]
    },
    {
      demo: 'fourGroupsWithOverlap',
      isReset: false,
      buttonText: 'Four Groups with Overlap',
      features: [
        '33% Group A and Group C',
        '17% Group A and Group D',
        '17% Group B and Group D',
        '33% Group B'
      ]
    }

  ]

  return (
    <DemoCard headerText='Groups' demos={demos} triggerDemo={triggerDemo} />
  )
}

export default Groups